import {
    Tooltip,
    Button,
    AccordionDetails,
    Accordion,
    AccordionSummary,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import { convertNumber } from '../../components/fields';
import { NUMBER } from '../../utils/Constants/MagicNumber';
import {
    VOID_ICON,
    CHANGE_PERIOD_ICON,
    REVERSE_ICON,
    DELETE_ICON,
} from '../../utils/Constants/ClassName';
import { BonusEarningModal } from './BonusEarningModal';
import { useState } from 'react';
import _ from 'lodash';
import { Box } from '@mui/material';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CRUD_UPDATE, useMutation,useNotify } from 'react-admin';
import { PROPAY_STATUS } from '../../constants';
import { USER_TYPE } from '../../utils/Constants/ConstantData';
const ResponsiveDetailView = props => {
    const {
        identity,
        setShowVoidModal,
        setShowChangeModal,
        data,
        total,
        detailData,
        isVoidSection,
        setVoidPropayId,
        setBonusRecordId,
        setPropayName,
        setShowReverseModal,
        setIsOverage
    } = props;
    const [earningModal,setEarningModal]=useState(false);

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const getTotalSum = (key: string) => {
        let sum =
            total > NUMBER.ZERO
                ? detailData?.reduce((value, currentValue) => {
                      return value + Number(currentValue.wage_id_obj[key]);
                  }, NUMBER.ZERO)
                : NUMBER.ZERO;
        return sum;
    };
    const savedHours = getTotalSum('saved_hours');

    const getPropayName = (propayObj: any) => {
        let parent = propayObj.parent_id
            ? propayObj.parent_id_obj.display_name
            : '';
        return parent
            ? parent + ` > ${propayObj.display_name}`
            : propayObj.display_name;
    };
    const dateFormat = date => moment(date).format('MMM DD, YYYY');
    const isLeadPay = (ids,propayId)=>ids.filter(it=>it.propay_id === propayId).length > NUMBER.ZERO;
    const getWagePercent = () => {
        let cl =
            ((data.total_increased_wage - data.normal_wage) /
                data.normal_wage) *
            NUMBER.HUNDRED;
        return cl.toFixed(NUMBER.TWO);
    };

    const voidAction = (row) => {
        setShowVoidModal(true);
        setIsOverage(row.deficit_amount)
        setBonusRecordId(row.id);
        setVoidPropayId(row.propay_id);
        setPropayName(getPropayName(row.propay_id_obj));
    };
    return (
        <>
            {!isVoidSection && (
                <div className="bonuses-box-row">
                    <div className="bonuses-box-item active-bonus-item">
                        <span>Total Bonus</span>
                        {formatter.format(data.total_earning > NUMBER.ZERO ? data.total_earning : NUMBER.ZERO)}
                    </div>
                    <div className="bonuses-box-item">
                        <span>Reserve</span>
                        {formatter.format(data?.reserve_amount)}
                    </div>
                    <div className="bonuses-box-item">
                        <span>Wage Increase</span>
                        {data.total_increased_wage > NUMBER.ZERO ?
                        <>
                        <div className='wage-increase-value-mobile'>
                        {formatter.format(data.total_increased_wage - data.normal_wage)}
                        ({getWagePercent()}%)
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="14"
                            viewBox="0 0 13 14"
                            fill="none"
                            className="wage-increase-icon"
                        >
                            <path
                                d="M1.6001 6L6.6001 1M6.6001 1L11.6001 6M6.6001 1V13"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        </div>
                        </>
                        :'$0.00'}
                    </div>
                    <div className="bonuses-box-item">
                        <span>Wage From</span>
                        {formatter.format(data.normal_wage)} to{' '}
                        {formatter.format(data.total_increased_wage ? data.total_increased_wage : data.normal_wage)}
                    </div>
                    <div className="bonuses-box-item">
                        <span>Saved Hours</span>
                        {convertNumber(savedHours, identity)} hrs.
                    </div>
                </div>
            )}
            <div className="adjust-time-accordion">
                {total > NUMBER.ZERO ? (
                    <>
                        {detailData.map(item => {
                            return (
                                <>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="bonus1a-content"
                                            id="bonus1a-header"
                                        >
                                            {getPropayName(item.propay_id_obj)}
                                            <span>
                                                {item.propay_id_obj.job_id_obj
                                                    .id
                                                    ? item.propay_id_obj
                                                          .job_id_obj.full_name
                                                    : ''}
                                            </span>
                                            {isLeadPay(item.lead_pay_ids_obj,item.propay_id_obj.parent_id || item.propay_id) ? (
                                            <Button className="overage-btn-bonus">
                                                LeadPay
                                            </Button>
                                        ) : (
                                            ''
                                        )}
                                            {item.deficit_amount >
                                            NUMBER.ZERO ? (
                                                <Button className="overage-btn-bonus">
                                                    Overage
                                                </Button>
                                            ) : (
                                                ''
                                                // <Button className="btn-bonus-green">
                                                //     Bonus
                                                // </Button>
                                            )}
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <div className="bonus-accordion-item">
                                                <span className="bonus-accordion-label">
                                                    Dates (Start ~ End)
                                                </span>
                                                {dateFormat(
                                                    item.propay_id_obj.from_date
                                                )}{' '}
                                                ~{' '}
                                                {dateFormat(
                                                    item.propay_id_obj.to_date
                                                )}
                                            </div>
                                            <div className="bonus-accordion-item">
                                                <span className="bonus-accordion-label">
                                                    Hours
                                                </span>
                                                {convertNumber(item.hours,identity)}
                                            </div>
                                            <div className="bonus-accordion-item">
                                                <span className="bonus-accordion-label">
                                                    Amount
                                                </span>
                                               {isLeadPay(item.lead_pay_ids_obj,item.propay_id_obj.parent_id || item.propay_id) ? 
                                               <span>{formatter.format(item.bonus_earning)}</span> :
                                                <span  className={`${item.deficit_amount ? 'red-text':'earning-link'}`} onClick={()=>setEarningModal(true)}>
                                                    {item.deficit_amount ? '-' : ''}
                                                    {formatter.format(item.deficit_amount ? item.deficit_amount: item.bonus_earning)}
                                                </span>}
                                                    {(!identity?.company?.remove_ot_diff && item.bonus_ot_diff_amt > NUMBER.ZERO)? (
                                                            <span className="ot-earning">
                                                        <Tooltip
                                                            title={`Overtime: ${formatter.format(
                                                                item.bonus_ot_diff_amt
                                                            )}`}
                                                        >
                                                            <span className="ot-earning-btn">
                                                                {' '}
                                                                OT{' '}
                                                            </span>
                                                        </Tooltip>
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}

                                                    {
                                                        isVoidSection ? <div className="bonus-accordion-item">
                                                        <span className="bonus-accordion-label">
                                                            Description
                                                        </span>
                                                        {item.description}
                                                    </div>:''
                                                    }

                                            </div>
                                            {earningModal && <BonusEarningModal
                                                      isOpen={earningModal}
                                                      isOverage={item.deficit_amount}
                                                      bonusDetailData={item.deficit_amount ? item.overage_ids_obj:item.bonus_ids_obj}
                                                     onClose={() =>setEarningModal(false)}
                                    />}
                                            {(data.status !== PROPAY_STATUS.PAID && identity?.user_type !== USER_TYPE.worker) && <div className="bonus-accordion-item">
                                                <div className="bonus-action-icons">
                                                    {isVoidSection ? (
                                                        <Tooltip
                                                            title="Reverse"
                                                            arrow
                                                            placement="top"
                                                            onClick={()=>{
                                                                setShowReverseModal(true);
                                                                setBonusRecordId(item.id)
                                                                setVoidPropayId(item.propay_id)
                                                            }}
                                                        >
                                                            {REVERSE_ICON()}
                                                        </Tooltip>
                                                    ) : (
                                                        <>
                                                            <Tooltip
                                                                title="Void"
                                                                placement="top"
                                                                arrow
                                                                onClick={() =>
                                                                    voidAction(
                                                                        item
                                                                    )
                                                                }
                                                            >
                                                                {VOID_ICON()}
                                                            </Tooltip>
                                                            <Tooltip
                                                                title="Change Statement Period"
                                                                arrow
                                                                onClick={() => {
                                                                    setShowChangeModal(
                                                                        true
                                                                    );
                                                                    setBonusRecordId(
                                                                        item.id
                                                                    );
                                                                }}
                                                                placement="top"
                                                            >
                                                                {CHANGE_PERIOD_ICON()}
                                                            </Tooltip>
                                                        </>
                                                    )}
                                                </div>
                                            </div>}
                                        </AccordionDetails>
                                    </Accordion>
                                </>
                            );
                        })}
                    </>
                ) : (
                    <Box sx={{ p: 1 }}>…Loading</Box>
                )}
            </div>
        </>
    );
};
export default ResponsiveDetailView;
